import * as types from '../../../constants/ActionTypes';
import service from '../../../service/';

export const setUserMail = event => ({
    type: types.SET_USER_MAIL,
    event,
    isValidMail: service.isValidMail(event.target.value),
});

export const setUserPassowrd = event => ({
    type: types.SET_USER_PASSWORD,
    event,
    isValidPassword: service.isValidPassword(event.target.value),
});

export const setUserAcceptRules = acceptedRules => ({
    type: types.SET_USER_ACCEPT_RULES,
    acceptedRules,
});

export const onBlurMail = () => ({
    type: types.ON_BLUR_MAIL,
    showMailError: true,
});

export const onBlurPassword = () => ({
    type: types.ON_BLUR_PASSWORD,
    showPasswordError: true,
});

export const register = data => ({
    type: types.REGISTER,
    payload: service.register(data),
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/Register/registerActions.js